import { html, property } from 'lit-element';
import { nothing } from 'lit-html';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './page-header.lit.scss';

/**
 * @component {kat-page-header} KatPageHeader Standardizes top-of-page information including the location and styling of alerts, the page title, and other common elements. Usage is recommended, but not required. If you don’t utilize this component, you should use ensure your page still has an H1 header and other, similar, elements in roughly the same order.
 * @subcomponent ./page-header-alerts.ts
 * @subcomponent ./page-header-page-actions.ts
 * @subcomponent ./page-header-utility-links.ts
 * @subcomponent ./page-header-utility-actions.ts
 */
@register('kat-page-header')
export class KatPageHeader extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  // Mapping of a component/slot name to their allowed components
  static slotMapping = {
    alerts: {
      name: 'kat-page-header-alerts',
      allowed: ['kat-alert'],
    },
    pageActions: {
      name: 'kat-page-header-page-actions',
      allowed: ['kat-button', 'kat-link'],
    },
    utilityActions: {
      name: 'kat-page-header-utility-actions',
      allowed: ['kat-button', 'kat-link'],
    },
    utilityLinks: {
      name: 'kat-page-header-utility-links',
      allowed: ['kat-link'],
    },
  };

  /** Header that will be displayed. */
  @property()
  header?: string;

  /** Header that will be displayed. */
  @property()
  subheader?: string;

  render() {
    const renderedHeader = this.header
      ? html`<h1>${this.header}</h1>`
      : nothing;

    const renderedSubheader = this.subheader
      ? html`<h2>${this.subheader}</h2>`
      : nothing;

    return html`<div class="wrapper">
      <div class="alerts">
        <slot name="${KatPageHeader.slotMapping.alerts.name}"></slot>
      </div>

      <div class="header">
        ${renderedHeader}
        <div class="utility-links">
          <slot name="${KatPageHeader.slotMapping.utilityLinks.name}"></slot>
        </div>
        <div class="utility-actions">
          <slot name="${KatPageHeader.slotMapping.utilityActions.name}"></slot>
        </div>
      </div>

      ${renderedSubheader}

      <slot></slot>

      <div class="page-actions">
        <slot name="${KatPageHeader.slotMapping.pageActions.name}"></slot>
      </div>
    </div>`;
  }
}
